import React, { useState } from 'react';
import { ContainerCheckBox } from './styles';

interface CheckBoxTestProps {
  firstLabel: string;
  value: string;
  handleOnChange: () => void;
  disabled?: boolean;
  style?: React.CSSProperties;
  checked?: boolean;
}

const CheckBox: React.FC<CheckBoxTestProps> = (props) => {
  const { firstLabel, value, handleOnChange, style, checked, disabled } = props;

  const [disparadorFocus, setDisparadorFocus] = useState(true);

  const handledisparadorFocus = () => {
    setDisparadorFocus(true);
    setTimeout(() => {
      setDisparadorFocus(false);
    }, 500);
  };

  return (
    <ContainerCheckBox data-testid="cmp-radio-button">
      <div className="orientationRadioButtons">
        <div style={{ display: 'flex' }}>
          <label className="text circle-label">
            <input
              disabled={disabled}
              style={{ visibility: 'inherit' }}
              data-testid="checkbox-input"
              onChange={handleOnChange}
              onClick={() => {
                handledisparadorFocus();
              }}
              type="checkbox"
              id="cbox1"
              checked={checked}
              value={value}
              name="checkBox"
              className={disparadorFocus ? 'focus-class' : ''}
            />
            <div className="circle__container">
              <div className="circle circle1">
                <div className="circle  circle2">
                  <div className="circle circle3" />
                </div>
              </div>
            </div>
            <p style={style}>{firstLabel}</p>
          </label>
        </div>
      </div>
    </ContainerCheckBox>
  );
};

export default CheckBox;
